import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FacebookLoginDirective } from './facebook-login.directive';
import { MemberLoadingFacebookComponent } from './member-loading-facebook/member-loading-facebook.component';
import { FacebookService } from './facebook.service';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    FacebookLoginDirective,
    MemberLoadingFacebookComponent,
  ],
  exports: [
    FacebookLoginDirective
  ],
})
export class FacebookMemberModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: FacebookMemberModule,
      providers: [FacebookService]
    };
  }
}
